const LOCALE = 'ru-RU';

export const getMonthString = (date: Date) => {
  const monthFormatter = new Intl.DateTimeFormat(LOCALE, { month: 'long' });
  const month = monthFormatter.format(date);

  switch (date.getMonth()) {
    case 2:
    case 7:
      return `${month}а`;
    default:
      return month.replace(/.$/, 'я');
  }
};

export const getLocaleDate = (date: Date) => {
  return date.toLocaleDateString('ru', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getMonthDayDate = (date: Date) => {
  return date.toLocaleDateString('ru', {
    month: 'long',
    day: 'numeric',
  });
};

export const getDetailedDateTime = (
  date: Date,
  options?: Intl.DateTimeFormatOptions,
) => {
  const timeFormatter = new Intl.DateTimeFormat(LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    ...options,
  });

  return {
    day: date.getDate(),
    month: getMonthString(date),
    year: date.getFullYear(),
    time: timeFormatter.format(date),
  };
};
